import React, { useEffect, useRef, useState } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import * as actions from '../../routes/actions/Account';
import storage from '../../services/storage';

const normalizeTarget = (value) => {
  if (!value) return '/';

  const target = value.startsWith('/') ? value : `/${value}`;

  if (target === '/dijital-etkilesimli-kitaplar') {
    return '/dijitalkitap';
  }

  return target;
};

function LoginWithToken(props) {
  const {
    history,
    loginExchange,
    loginRequired,
    refreshUserInStorage,
    user,
  } = props;
  const [loading, setLoading] = useState(false);
  const handledTokenRef = useRef(null);

  // read token, target/path from query string
  const urlParams = new URLSearchParams(window.location.search);
  const token = urlParams.get('token');
  const target = normalizeTarget(urlParams.get('target') || urlParams.get('path'));
  const shouldClearLocalStorage = urlParams.get('clear') || 'false';

  useEffect(() => {
    const redirectToLogin = () => {
      history.replace('/');
      loginRequired(true, target);
      setLoading(false);
    };

    async function handleLogin() {
      if (shouldClearLocalStorage === 'true') {
        storage.removeAuth();

        var targetStartsWithDesk = target.startsWith('/dijitalkitap');
        if (targetStartsWithDesk) {
          redirectToLogin();
          return;
        }

        history.replace(target);
        return;
      }

      // ÖNEMLİ: Token varsa ÖNCE token exchange yap, sonra user kontrolü
      if (token) {
        if (handledTokenRef.current === token) {
          return;
        }

        handledTokenRef.current = token;
        setLoading(true);
        const { success } = await loginExchange(token);
        if (success) {
          // Kullanıcı bilgilerini yenile
          await refreshUserInStorage();
          const storedUser = storage.getUser();
          if (storedUser && storedUser.id) {
            history.replace(target);
            return;
          }
        }

        redirectToLogin();
        return;
      }

      // Token yoksa ve user varsa direkt yönlendir
      if (user && user.id) {
        history.replace(target);
        return;
      }

      // Token yok, user yok -> login sayfasına
      var shouldRequireDeskLogin = target.startsWith('/dijitalkitap');
      if (shouldRequireDeskLogin) {
        redirectToLogin();
        return;
      }

      history.replace('/');
    }
    handleLogin();
  }, [
    token,
    target,
    shouldClearLocalStorage,
    history,
    loginExchange,
    loginRequired,
    refreshUserInStorage,
    user,
  ]);

  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        flexDirection: 'column',
      }}
    >
      {loading ? (
        <>
          <h1>Yönlendiriliyorsunuz...</h1>
          <div className="spinner-border text-primary" role="status">
            <span className="sr-only">Yönlendiriliyorsunuz...</span>
          </div>
        </>
      ) : null}
    </div>
  );
}

const mapStateToProps = ({ AccountReducer }) => ({
  user: AccountReducer.user,
  token: AccountReducer.token,
});

const mapDispatchToProps = {
  loginExchange: actions.loginExchange,
  loginRequired: actions.loginRequired,
  refreshUserInStorage: actions.refreshUserInStorage,
};
export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withRouter(LoginWithToken));
